import { type Currency, formatCurrencyAmount, formatPhoneNumber, NoddiDateFormats, noddiFormatDate } from 'noddi-util';
import { ReactNode } from 'react';
import { PrettySlug } from './PrettySlug';

export type InfoValueType = 'date' | 'date-time' | 'currency' | 'phone' | 'boolean' | 'time' | 'slug';

export const getInfoTextToCopy = (rawValue: ReactNode, formattedValue: ReactNode, type?: InfoValueType): string => {
  if (type === 'slug' && typeof rawValue === 'string') {
    return rawValue.toUpperCase();
  }

  const text =
    typeof formattedValue === 'string'
      ? formattedValue
      : typeof rawValue === 'string' || typeof rawValue === 'number' || typeof rawValue === 'boolean'
        ? String(rawValue)
        : '';

  if (type === 'phone') {
    return text.replace(/\s/g, '');
  }

  return text;
};

export const formatInfoValue = (value: ReactNode, type: InfoValueType | undefined, currency?: Currency): ReactNode => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  switch (type) {
    case 'date':
      if (typeof value === 'string') {
        return noddiFormatDate(value, NoddiDateFormats.DATE);
      }
      return '-';

    case 'date-time':
      if (typeof value === 'string') {
        return noddiFormatDate(value, NoddiDateFormats.DATE_TIME);
      }
      return '-';

    case 'time':
      if (typeof value === 'string') {
        // Already-formatted time string — return as-is
        if (/^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
          return value;
        }
        return noddiFormatDate(value, NoddiDateFormats.TIME);
      }
      return '-';

    case 'currency':
      if (typeof value === 'number') {
        return formatCurrencyAmount({
          money: {
            amount: value,
            currency: currency ?? 'NOK'
          }
        });
      }
      return '-';

    case 'phone':
      if (typeof value === 'string') {
        return formatPhoneNumber(value);
      }
      return '-';

    case 'boolean':
      if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
      }
      return '-';

    case 'slug':
      if (typeof value === 'string') {
        return <PrettySlug slug={value} />;
      }
      return '-';

    default:
      return value;
  }
};
